import { createSelector } from 'reselect';
import { StoreState } from 'src/store/reducers';
import { IStudent } from 'src/types/student';
import { SelectableItem } from 'src/enumerables/enumerable.abstract';

export const Selector = (state: StoreState) => state.students.data.list;
export const mappedStaffSelector = createSelector(Selector, (staff: IStudent[]): SelectableItem[] =>
    staff.map((item: IStudent) => ({ name: item.firstName, value: item.id })),
);
export const selectNameStudents = createSelector(Selector, (items): { label: string; value: number | string }[] => {
    const arrSel: { label: string; value: number | string }[] = [];

    items.forEach((item: IStudent) => {
        arrSel.push({ label: `${item?.firstName} ${item?.lastName}`, value: item.id });
    });
    arrSel.sort((a: SelectObject, b: SelectObject) => {
        const textA = a.label.toUpperCase();
        const textB = b.label.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    return arrSel;
});
export const miniLoaderForSelector = (state: StoreState) => state.students.miniLoaderFor;
export const loaderSelector = (state: StoreState) => state.students.inProgress;
export const selectNameSerLocations = createSelector(Selector, (items) => {
    const ids: { [key: string]: string } = {};

    items.forEach((item: IStudent) => {
        ids[item.id] = item.firstName;
    });

    return ids;
});
